module.exports = __webpack_public_path__ + "img/mastercard.8344e47d.svg";